import React, { useState } from 'react';
import { FaSearch, FaFilePdf, FaEnvelope } from 'react-icons/fa';
import HeadingWithWatermark from '../component/HeadingWithWatermark';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';

// Theme colors
const primaryBlue = 'rgb(43, 147, 208)';
const yellowAccent = '#fbbf24';

// Static newsletters data for Jan 2025 - Jan 2026
const newslettersData = [
  {
    id: '2025-1',
    title: 'WASME Monthly Newsletter - January 2025',
    month: 'January',
    year: 2025,
    description: 'Highlights and updates from WASME\'s global MSME initiatives for January 2025. Feature articles, success stories, and upcoming events.',
    pdfUrl: '#',
    image: '/img/newsletter1.png',
  },
  {
    id: '2025-2',
    title: 'WASME Monthly Newsletter - February 2025',
    month: 'February',
    year: 2025,
    description: 'Highlights and updates from WASME\'s global MSME initiatives for February 2025. Feature articles, success stories, and upcoming events.',
    pdfUrl: '#',
    image: '/img/newsletter2.png',
  },
  {
    id: '2025-3',
    title: 'WASME Monthly Newsletter - March 2025',
    month: 'March',
    year: 2025,
    description: 'Highlights and updates from WASME\'s global MSME initiatives for March 2025. Feature articles, success stories, and upcoming events.',
    pdfUrl: '#',
    image: '/img/newsletter3.png',
  },
  {
    id: '2025-4',
    title: 'WASME Monthly Newsletter - April 2025',
    month: 'April',
    year: 2025,
    description: 'Highlights and updates from WASME\'s global MSME initiatives for April 2025. Feature articles, success stories, and upcoming events.',
    pdfUrl: '#',
    image: '/img/newsletter4.png',
  },
  {
    id: '2025-5',
    title: 'WASME Monthly Newsletter - May 2025',
    month: 'May',
    year: 2025,
    description: 'Highlights and updates from WASME\'s global MSME initiatives for May 2025. Feature articles, success stories, and upcoming events.',
    pdfUrl: '#',
    image: '/img/july_newsletter.png',
  },
  {
    id: '2025-6',
    title: 'WASME Monthly Newsletter - June 2025',
    month: 'June',
    year: 2025,
    description: 'Highlights and updates from WASME\'s global MSME initiatives for June 2025. Feature articles, success stories, and upcoming events.',
    pdfUrl: '#',
    image: '/img/Nov_Newsletter.png',
  },
 
  
];

const WASMENewsletters = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredNewsletters, setFilteredNewsletters] = useState(newslettersData);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = newslettersData.filter(
      (news) =>
        news.title.toLowerCase().includes(query) ||
        news.month.toLowerCase().includes(query) ||
        news.year.toString().includes(query)
    );
    setFilteredNewsletters(filtered);
  };

  return (
    <>
    <Navbar/>
     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
    
   

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Page Header */}
        <div className="text-center mb-8">
          
        <HeadingWithWatermark
          title="Newsletters"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Stay informed with our monthly publications featuring global MSME insights, success stories, and resources.
          </p>
        </div>

        {/* Search Bar */}
        <div className="max-w-xl mx-auto mb-12">
          <div className="relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search by title, month, or year..."
              value={searchQuery}
              onChange={handleSearch}
              className="w-full pl-12 pr-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent shadow-sm"
            />
          </div>
        </div>

        {/* Newsletter Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredNewsletters.length > 0 ? (
            filteredNewsletters.map((newsletter) => (
              <div
                key={newsletter.id}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow overflow-hidden border border-gray-100 flex flex-col md:flex-row"
              >
                {/* Left side - Image with month badge */}
       <div className="md:w-1/3 lg:w-1/4 relative flex items-center justify-center">
  <img
    src={newsletter.image}
    alt={`${newsletter.month} ${newsletter.year} newsletter cover`}
    className="max-h-56 object-contain"
  />

  {/* Month badge */}
  <div
    className="absolute top-1 left-1 px-3 py-1 rounded-full  text-xs font-semibold shadow-lg"
    style={{ backgroundColor:' rgb(43, 147, 208)', color: "#ffff" }}
  >
    {newsletter.month} {newsletter.year}
  </div>
</div>

                {/* Right side - Content */}
                <div className="flex-1 p-6 flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{newsletter.title}</h3>
                    <p className="text-gray-600 mb-4">{newsletter.description}</p>
                  </div>
                  <div>
                    <a
                      href={newsletter.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-5 py-2 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
                      style={{ backgroundColor: primaryBlue }}
                    >
                      <FaFilePdf className="mr-2" />
                      View PDF
                    </a>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-12 text-gray-500">
              No newsletters found matching your search.
            </div>
          )}
        </div>

        {/* Subscription Box */}
        {/* <div className="max-w-2xl mx-auto mt-16">
          <div className="bg-white rounded-2xl p-8 border border-gray-200 text-center shadow-lg">
            <FaEnvelope className="text-4xl mx-auto mb-4" style={{ color: primaryBlue }} />
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">Subscribe to Our Newsletter</h3>
            <p className="text-gray-600 mb-6">
              Receive monthly updates directly in your inbox. No spam, just valuable insights.
            </p>
            <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent"
                required
              />
              <button
                type="submit"
                className="px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
                style={{ backgroundColor: primaryBlue }}
              >
                Subscribe
              </button>
            </form>
            <p className="text-xs text-gray-500 mt-4">
              By subscribing, you agree to our Privacy Policy and consent to receive updates.
            </p>
          </div>
        </div> */}
      </main>

  
    </div>
    <Footer/>
    </>
   
  );
};

export default WASMENewsletters;